// extracted by mini-css-extract-plugin
module.exports = {"phoneField":"EditPhoneModal_phoneField__U9VbJ","intlWrap":"EditPhoneModal_intlWrap__UZYuo"};